export default class PaginationHandler {

	static paginate({ dataRows, page, perPage }) {
		let start = (page - 1) * perPage;
		let end = page * perPage;

		return dataRows.slice(start, end);
	}
}
